export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 text-center">
          Trending Categories
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-3 max-w-md mx-auto">
          Explore our most popular sourcing categories powered by the
          itaobuyspreadsheet system
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mt-12">
          <a
            href="https://kaspreadsheet.com/category-911-Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative block aspect-square rounded-2xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Closeup%20of%20premium%20handcrafted%20leather%20sneakers%20on%20textured%20limestone%20surface%20with%20dramatic%20side%20lighting%20casting%20soft%20shadows%20minimal%20editorial%20product%20photography%20rich%20cognac%20and%20cream%20tones%20visible%20stitching%20and%20texture%20details%20clean%20luxurious%20aesthetic&width=800&height=800&seq=feat-v2-shoes&orientation=squarish"
              alt="Shoes category on itaobuyspreadsheet"
              title="Shoes - ItaobuySpreadsheet Sourcing"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="bg-white/85 backdrop-blur-sm rounded-xl px-6 py-3 text-center">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                  Shoes
                </h3>
                <p className="text-xs text-foreground-500 mt-1">Shop Main Site</p>
              </div>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-912/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative block aspect-square rounded-2xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Oversized%20organic%20cotton%20hoodie%20draped%20casually%20over%20vintage%20wooden%20ladder%20back%20chair%20in%20sunlit%20room%20with%20whitewashed%20walls%20soft%20morning%20light%20streaming%20through%20linen%20curtains%20editorial%20fashion%20photography%20warm%20oatmeal%20tones%20cozy%20minimal%20aesthetic&width=800&height=800&seq=feat-v2-hoodies&orientation=squarish"
              alt="Hoodies Sweaters category on itaobuyspreadsheet"
              title="Hoodies Sweaters - ItaobuySpreadsheet Sourcing"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="bg-white/85 backdrop-blur-sm rounded-xl px-6 py-3 text-center">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                  Hoodies/Sweaters
                </h3>
                <p className="text-xs text-foreground-500 mt-1">Shop Main Site</p>
              </div>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-913/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative block aspect-square rounded-2xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Artistically%20folded%20premium%20cotton%20t-shirts%20in%20warm%20earth%20tones%20arranged%20in%20a%20wooden%20crate%20at%20outdoor%20artisan%20market%20setting%20soft%20golden%20hour%20sunlight%20natural%20shadows%20editorial%20product%20photography%20organic%20textures%20rustic%20minimal%20composition%20visible%20fabric%20weave&width=800&height=800&seq=feat-v2-tshirts&orientation=squarish"
              alt="T-Shirts category on itaobuyspreadsheet"
              title="T-Shirts - ItaobuySpreadsheet Sourcing"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="bg-white/85 backdrop-blur-sm rounded-xl px-6 py-3 text-center">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                  T-Shirts
                </h3>
                <p className="text-xs text-foreground-500 mt-1">Shop Main Site</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}